import { useSignal } from "@preact/signals-react";
import { FormattedMessage as FM } from "react-intl";

import { classNames as cn } from "tools/ui";

function OptionsFilter({ name, options, model, handleFilter }) {
  const activeCleaning = useSignal([]);

  function onFilter(option) {
    const options = activeCleaning.value;
    const index = options.indexOf(option);
    if (index >= 0) {
      options.splice(index, 1);
    } else {
      options.push(option);
    }
    activeCleaning.value = options;
    handleFilter(name, options);
  }

  return (
    <div className="flex space-x-3">
      {Object.entries(options).map(([option, style]) => (
        <button
          key={option}
          type="button"
          className={cn(
            "flex py-2 px-3 md:w-20 lg:w-28 rounded-xl text-sm text-center active:scale-95",
            style,
          )}
          onClick={() => onFilter(option)}
        >
          <FM id={`${model}.${option}`} />
          {activeCleaning.value.includes(option) && (
            <span className="ml-auto">✓</span>
          )}
        </button>
      ))}
    </div>
  );
}

export default OptionsFilter;
